import styled, { css } from "styled-components";
import { transparentize } from "polished";

export const StyledHero = styled.div`
    overflow: hidden;
    margin-top: 50px;
    position: relative;
    ${p =>
        p.theme.md.min(css`
            height: 596px;
        `)}
`;

export const Background = styled.div`
    background-size: cover;
    background-position: right center;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    ${p =>
        p.theme.sm.max(css`
            background-position: center;
            background-size: cover;
        `)}
    ${p =>
        p.theme.xs(css`
            background-size: cover;
            background-position: -56px bottom;

            @media (min-width: 400px) {
                background-position: 0 bottom;
            }
        `)}
`;

export const HeroContent = styled.div`
    position: relative;
    width: 100%;
    background: linear-gradient(
        to right,
        ${p => transparentize(0.15, p.theme.c.boost)} 0%,
        ${p => transparentize(1, p.theme.c.white)} 75%
    );
    overflow: hidden;
    height: 100%;
    padding: 40px;
    box-sizing: border-box;
    padding-right: 200px;
    color: #eee;
    z-index: 0;

    ${p =>
        p.theme.sm.max(css`
            height: auto;
            padding: 16px;
            background: linear-gradient(
                to bottom,
                ${p => transparentize(0.64, p.theme.c.active)} 0%,
                ${p => transparentize(0.36, p.theme.c.active)} 100%
            );
        `)}

    h1 {
        font-size: 36px;
        margin-top: 0;
        width: 500px;
        font-weight: 600;
        line-height: 1.4;
        color: ${p => p.theme.c.info};
        text-shadow: 1px 1px 2px ${p => p.theme.c.blackShadow3};

        ${p =>
            p.theme.sm.max(css`
                font-size: 28px;
                text-align: center;
                width: auto;
            `)}
    }

    h2 {
        font-weight: 400;
        color: ${p => p.theme.c.white};
        text-shadow: 1px 1px 2px ${p => p.theme.c.blackShadow3};
        ${p =>
            p.theme.sm.min(css`
                width: 400px;
            `)}

        ${p =>
            p.theme.sm.max(css`
                margin-left: auto;
                margin-right: auto;
                font-size: 20px;
                text-align: center;
                line-height: 30px;
            `)}
    }
`;

export const ButtonWrapper = styled.div`
    display: inline-block;
    margin-right: 0;

    ${p =>
        p.theme.sm.max(css`
            display: block;
            text-align: center;
            margin-bottom: 10px;
        `)}
`;

export const LaunchContainer = styled.div`
    display: inline-block;

    background-color: ${p => p.theme.c.info};
    font-size: 26px;
    font-weight: 400;
    padding: 10px 24px;
    text-align: center;
    box-shadow: 5px 5px 6px 0 rgba(0, 0, 0, 0.17);
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
    margin: 40px auto 24px -40px;
    padding-left: 40px;
    position: relative;
    border-radius: 0 8px 8px 0;

    ${p =>
        p.theme.sm.max(css`
            display: block;
            font-size: 22px;
            padding: 8px 16px;
            margin: 24px auto;
            border-radius: 8px;
        `)}
`;

export const ToEducation = styled.a`
    background-color: ${p => p.theme.c.mainBoost};
    font-size: 21px;
    font-weight: 400;
    padding: 10px 16px;
    text-align: center;
    box-shadow: 5px 5px 6px 0 rgba(0, 0, 0, 0.17);
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
    margin: 40px auto 30px -40px;
    padding-right: 40px;
    position: absolute;
    bottom: 0px;
    right: 0;
    border-radius: 8px 0 0 8px;
    .i-arrowback {
        color: ${p => p.theme.c.white};
        font-size: 32px;
        margin: -10px;
        margin-left: 0px;
        display: inline-block;
        position: relative;
        top: 7px;
        transform: scale(-1, 1);
        @media (max-width: 350px) {
            display: none;
        }
    }

    ${p =>
        p.theme.sm.max(css`
            display: block;
            position: static;
            font-size: 17px;
            padding: 8px 16px;
            margin: 24px auto;
            border-radius: 8px;
        `)}
`;
